<template>
   <v-layout wrap>
      <v-btn @click="onClose"
         text
      >
         {{$t('common.back', locale)}}
      </v-btn>
      <v-flex xs12>
         <center>
         <v-progress-linear
            v-if="loading"
            indeterminate
            :color="content.BookingActWeekPrimaryColor"
         />
         <v-date-picker
            no-title
            v-model="selectedDate"
            :events="functionEvents"
            :picker-date.sync="pickerDate"
            @change="handleChangeDate"
            :locale="locale"
            :min="min"
            :disabled="loading"
         />
         </center>
      </v-flex>
      <v-flex xs3
         style="padding: 10px;"
         v-for="item of hours"
         :key="item.id"
      >
         <reservation-form
            :event="item"
            :locale="locale"
            :color="content.BookingActWeekPrimaryColor"
            :timeLimit="selectedActivity.TimeLimit !== null"
         />
         <!--v-chip
            v-for="item of hours"
            :key="item.id"
            @click="handleSelectTime(item)"
            style="margin: 5px"
         >
          {{item.time}}
         </v-chip-->
      </v-flex>
      <v-flex v-if="timeLimit" style="padding: 20px">
         <center>
            <small>{{timeLimit}}</small>
         </center>
      </v-flex>
   </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import utils from '@/services/utils'
import ReservationForm from './ReservationForm'
export default {
   components: {
      ReservationForm,
   },
   props: {
      selectedActivity: {
         type: Object,
         required: true,
      },
      onClose: {
         type: Function,
         required: true,
      },
      locale: {
         type: String,
         required: true,
      },
      content: {
         type: Object,
         required: true,
      },
      config: {
         type: Object,
         required: true,
      },
   },
   data: () => ({
      loading: false,
      dates: [],
      hours: null,
      selectedDate: null,
      pickerDate: null,
      selectedTime: null,
   }),
   computed: {
      ...mapState('app', ['dtouchWorkspace']),
      min () {
         return new Date().toISOString().split('T').shift()
      },
      timeLimit () {
         const t = this.selectedActivity.TimeLimit
         if (!t) return

         const aux = []
         if (t.from) {
            aux.push(`desde ${t.from.limit} ${t.from.type}`)
         }
         if (t.to) {
            aux.push(`hasta ${t.to.limit} ${t.to.type}`)
         }
         return `(*) Se puede reservar ${aux.join(', ')} antes`
      },
   },
   watch: {
      pickerDate () {
         this.handleGetDates()
      },
   },
   mounted () {
      console.log(this.content)
      this.handleGetDates()
   },
   methods: {
      parseJSON (v) {
         return typeof v === 'string' ? JSON.parse(v) : v
      },
      getTranslation (v, locale) {
         return utils.getTranslation(v, locale)
      },
      functionEvents (v) {
         if (this.dates.filter(x => x.date === v).length > 0) return ['green']
         return null
      },
      handleGetDates () {
         this.handleSelectTime()
         this.loading = true
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/cm/${this.dtouchWorkspace}/activities/${this.selectedActivity.ID}/events`
         const filter = {
            source: this.selectedActivity.Source,
            month: this.pickerDate
         }
         axios.post(url, filter)
            .then((response) => {
               this.dates = response.data.map(item => {
                  item.sTime = utils.convertTime(item.Time)
                  item.date = item.Date.split('T').shift()
                  return item
               })
            })
            .catch((error) => {
               console.log(error)
            })
            .then(() => {
               this.loading = false
            })
      },
      handleChangeDate () {
         this.handleSelectTime()
         this.hours = this.dates.filter(x => x.date === this.selectedDate)
      },
      handleSelectTime (v) {
         if(!v) return
         console.log('jhm', v)
         this.selectedTime = v.id
      },
   },
}
</script>

